import { NgModule } from '@angular/core';
import { ContactsLibComponent } from './contacts-lib.component';
import { ContactListComponent } from './components/contact-list/contact-list.component';

@NgModule({
  imports: [
  ],
  declarations: [ContactsLibComponent, ContactListComponent],
  exports: [ContactsLibComponent, ContactListComponent]
})
export class ContactsLibModule { }
